export const URL_MAIN = process.env.NODE_ENV === 'production' ? "https://bigdogbone.up.railway.app" : 'http://localhost:3002'
//'https://server-test-production-e401.up.railway.app'
//"https://server-test-production-e965.up.railway.app"
// 'http://localhost:3004'
//'https://bigdogbone.up.railway.app'
//'http://localhost:3002'

export const rutas = {
    
    login: `${URL_MAIN}/api/login`,
    getInformacion: `${URL_MAIN}/api/getInformacion`,
    mision: `${URL_MAIN}/api/mision`,
    finalizar: `${URL_MAIN}/api/finalizar`,
    retiro: `${URL_MAIN}/api/retiro`,
    retiroInterno: `${URL_MAIN}/api/retiroInterno`,
    changePass: `${URL_MAIN}/api/changePass`,
    loginPass: `${URL_MAIN}/api/loginPass`,
    mirarStake: `${URL_MAIN}/api/mirarStake/`,
    retirarTicket: `${URL_MAIN}/api/retirarTicket/`,
    retiroStake: `${URL_MAIN}/api/retiroStake/`,
    stakeIngreso: `${URL_MAIN}/api/stakeIngreso/`,
    abrirTicket: `${URL_MAIN}/api/abrirTicket/`,
    deposit: `${URL_MAIN}/api/deposit`,
    abrirPack: `${URL_MAIN}/api/abrirPack`,
    crafting: `${URL_MAIN}/api/crafting`,
    ingresoStakePool: `${URL_MAIN}/api/ingresoStakePool`,
    mirarPool: `${URL_MAIN}/api/mirarPool`,
    ecosistemaHueso: `${URL_MAIN}/api/ecosistemaHueso`,
    smartContract: 'https://api.hive-engine.com/rpc/contracts/',
    ingresoStakeKod:`${URL_MAIN}/api/ingresoStakeKod`,
    retirarStakePasivo:`${URL_MAIN}/api/retirarStakePasivo`,
    mirarStakePasivo:`${URL_MAIN}/api/mirarStakePasivo`,
    getCards:`${URL_MAIN}/api/getCard`,


    
    
    
}